import { Component, Input, OnInit } from '@angular/core';
import { RegionAttachable, Widget, WidgetMap } from '../../../../models/widget';
import { EditorEntityListComponentBase } from '../editor-object-list/editor-object-list.component';

@Component({
  selector: 'cw-editor-map-list',
  templateUrl: './map-list.component.html',
  styleUrls: ['./map-list.component.css']
})

export class EditorMapListComponent extends EditorEntityListComponentBase implements OnInit {
  @Input() widget: Widget;

  maps: WidgetMap[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.maps = this.widget.maps;
  }

  isSelected(entity: RegionAttachable) {
    if (!this.selectedRegion) {
      return false;
    }
    const region = this.getRegion(entity);
    return region && this.selectedRegion.id === region.id;
  }

}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-editor/editor-map-list/map-list.component.ts